import Cookies from 'universal-cookie';

// New cookies instance
const cookies = new Cookies();
const isSecureContext =
  typeof window !== 'undefined' && window.location.protocol === 'https:';

const tokenHandling = {
  saveAccessToken: (payload) => {
    // The cookie expires after 1 hour
    cookies.set('accessToken', payload, {
      path: '/',
      maxAge: 3600,
      sameSite: 'lax',
      secure: isSecureContext,
    });
  },
  saveRefreshToken: (payload) => {
    localStorage.setItem('refreshToken', payload);
  },
  retrieveToken: () => {
    return cookies.get('accessToken');
  },
  retrieveRefreshToken: () => {
    return localStorage.getItem('refreshToken');
  },
  removeToken: () => {
    sessionStorage.clear();
    localStorage.clear();
    cookies.remove('accessToken', {
      path: '/',
      sameSite: 'lax',
      secure: isSecureContext,
    });
  },
};

export const {
  saveAccessToken,
  saveRefreshToken,
  retrieveToken,
  retrieveRefreshToken,
  removeToken,
} = tokenHandling;
